/**
 * author: Patrick Vyn Badiang
 *
 * description:
 * takes in the path passed down, then makes a new accordian
 * with the file content from the path.
 */
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { styled } from '@mui/system';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";


const CustomAccordion = styled(Accordion)(({ theme }) => ({
    background: theme.palette.background.paper,
    borderRadius: '4px',
    boxShadow: 'none',
    '&:before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: 0,
    },
}));

const Article = (props) => {


    const [file, setFile] = useState('');

    useEffect(() => {
    fetch(props.path)
      .then(response => response.text())
      .then(content => setFile(content))
      .catch(error => console.log(error));
    }, [props.path]);

    return (
        <CustomAccordion disableGutters>
            <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main', fontSize: { xs: '24px', md: '30px' } }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ px: { xs: '16px', md: '28px' }, py: { xs: '4px', md: '10px' } }}>
                <Typography sx={{
                    fontFamily: 'Anton, sans-serif',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontSize: { xs: '17px', md: '20px', lg: '22px' },
                    color: 'primary.main',
                }}>
                    {props.title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: '#2b2b2b', lineHeight: 1.6 }}>
                    {file}
                </Typography>
            </AccordionDetails>
        </CustomAccordion>
    );

}

export default Article;
